import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggle}
      aria-label={dark ? "Basculer en mode clair" : "Basculer en mode sombre"}
      title={`Thème actuel : ${dark ? "sombre" : "clair"}`}
      className={`p-2 rounded-lg border border-slate-200 text-slate-500 hover:text-slate-900 hover:border-slate-400 transition-colors ${className}`}
    >
      {dark ? <Moon size={16} /> : <Sun size={16} />}
      <span className="sr-only" data-testid="theme-current-label">{dark ? "sombre" : "clair"}</span>
    </button>
  );
};

export default ThemeToggle;
